import Spinner from "react-spinkit";
import React from "react";

export default props => (
    <div className="spinner-inline-wrapper">
        <Spinner name="three-bounce" fadeIn="none" {...props}/>
    </div>
);